<template>
  <figure :class="$route.path.includes('forgot') ? '--surpress' : ''" class="helper-bg" >
    <img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="" />
  </figure>
</template>

<script>
export default {
  name: 'HelperBg'
}
</script>

<style lang="scss" scoped>
figure {
  width: 100%;
  height: 100%;
  border: 1rem solid #B9E857;
  display: none;
  overflow: hidden;
  background: {
    image: url(~@/assets/backgrounds/lightning.svg);
    repeat: repeat;
    position: center center;
    size: 40px auto;
    color: #B9E857; // green
  }
  &.--surpress {
    border: 0;
    padding: 0;
  }
  @media ( $screen-md ) {
    display: flex;
  }
}
</style>
